import React from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { LinkToNewTab } from "../../Elements/Link/Link.js";

const CustomTermsItem = () => {
  const { getTextByKey } = useContent();
  return (
    <div className="custom-label">
      {getTextByKey("agree-to-the")}
      <LinkToNewTab page="jumbo-pay-terms " isNewTab={true}>
        {getTextByKey("terms-of-use")}
      </LinkToNewTab>
    </div>
  );
};

export default CustomTermsItem;
